module.exports = __webpack_public_path__ + "static/img/weather21.5d5c485a.png";